'use client';

import { useEffect, useState } from 'react';
import { birKezYenile, dagitimKaymasiMi } from '@/lib/error/deploy-skew';

/**
 * Kok yerlesimin kendisi coktugunde gosterilen son sinir. Kok yerlesim gitmis
 * oldugu icin html/body burada kurulur; Tailwind de yuklu degildir, stiller satir ici.
 *
 * 29 Eylul 2026: Google bir biyografinin ozeti olarak "Bir seyler cok yanlis gitti!
 * Tekrar Dene" gosteriyordu. Bu ekran 200 ile ciziliyor ve dizine girebiliyordu.
 * Simdi: dagitim kaymasi hatalarinda sayfa bir kez kendini yeniler; kalan durumlarda
 * noindex ile cizilir, dili adresten alir ve ana sayfaya yol gosterir.
 */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [yenileniyor, setYenileniyor] = useState(false);
  const en = typeof window !== 'undefined' && /^\/en(\/|$)/.test(window.location.pathname);

  useEffect(() => {
    console.error(error);
    if (dagitimKaymasiMi(error) && birKezYenile()) setYenileniyor(true);
  }, [error]);

  const baslik = en ? 'Something went wrong' : 'Bir şeyler yanlış gitti';
  const metin = en
    ? 'The page could not be displayed. Please try again; if it keeps happening, return to the home page.'
    : 'Sayfa görüntülenemedi. Tekrar deneyin; sorun sürerse ana sayfaya dönün.';

  return (
    <html lang={en ? 'en' : 'tr'}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noindex" />
        <title>{`${baslik} - Biyografya`}</title>
      </head>
      <body style={{ margin: 0, background: '#faf8f4', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif", color: '#22376e' }}>
        <div style={{ maxWidth: 480, margin: '80px auto', padding: '0 20px', textAlign: 'center' }}>
          <p style={{ fontSize: 22, fontWeight: 700, margin: '0 0 12px', color: '#bf1e2e' }}>Biyografya</p>
          {yenileniyor ? (
            <p style={{ fontSize: 15, color: '#5b6a92' }}>{en ? 'Refreshing...' : 'Yenileniyor...'}</p>
          ) : (
            <>
              <h1 style={{ fontSize: 20, margin: '0 0 12px' }}>{baslik}</h1>
              <p style={{ fontSize: 15, lineHeight: 1.6, color: '#5b6a92', margin: '0 0 20px' }}>{metin}</p>
              <button
                type="button"
                onClick={() => reset()}
                style={{ background: '#bf1e2e', color: '#fff', border: 0, borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 700, cursor: 'pointer', marginRight: 10 }}
              >
                {en ? 'Try again' : 'Tekrar Dene'}
              </button>
              <a href={en ? '/en' : '/tr'} style={{ color: '#22376e', fontSize: 14, fontWeight: 600 }}>
                {en ? 'Home page' : 'Ana sayfa'}
              </a>
              {error?.digest && (
                <p style={{ fontSize: 11, color: '#9aa3bd', marginTop: 24 }}>{error.digest}</p>
              )}
            </>
          )}
        </div>
      </body>
    </html>
  );
}
